<template>
  <div class="page">
    <header class="page-cover">
      <div class="text-center">

        <div class="user-avatar user-avatar-xxl fileinput-button">
          <div class="fileinput-button-label"> Change photo </div>
          <img :src="this.$store.getters.photo_profile" alt="" v-if="this.$store.getters.photo_profile">
          <div class="tile tile-circle tile-xxl" style="display:block" :class="getRandomBg()" v-else>{{detail.initial}}</div>
          <input id="fileupload-avatar" type="file" name="avatar" @change="onFileChange">
        </div>

        <h2 class="h4 mt-2 mb-0"> {{ detail.full_name }} </h2>
        <p class="text-muted"> {{ detail.emp_position }} [ {{ detail.parent_number }} ] </p>
        <p> {{ detail.var_name }} </p>
      </div><!-- .cover-controls -->
    </header>
    <nav class="page-navs">
      <!-- .nav-scroller -->
      <div class="nav-scroller">
        <ul class="nav nav-center nav-tabs">
          <li class="nav-item">
            <a href="#" class="nav-link active" @click.prevent="setActive('biodata')" data-toggle="tab">Biodata</a>
          </li>
          <li class="nav-item">
            <a href="#" class="nav-link" @click.prevent="setActive('employment')" data-toggle="tab">Employment</a>
          </li>
          <li class="nav-item">
            <a href="#" class="nav-link" @click.prevent="setActive('family')" data-toggle="tab">Family</a>
          </li>
          <li class="nav-item">
            <a href="#" class="nav-link" @click.prevent="setActive('personel-data')" data-toggle="tab">Personel Data</a>
          </li>
          <li class="nav-item">
            <a href="#" class="nav-link" @click.prevent="setActive('contacts')" data-toggle="tab">Contacts</a>
          </li>
          <li class="nav-item">
            <a href="#" class="nav-link" @click.prevent="setActive('activities')" data-toggle="tab">Activities</a>
          </li>
        </ul>
      </div>
      <!-- /.nav-scroller -->
    </nav>

    <div class="card-body">
      <div class="tab-content py-3" id="myTabContent">
        <div class="tab-pane fade" :class="{ 'active show': isActive('overview') }">
          Overview
        </div>
        <div class="tab-pane fade" :class="{ 'active show': isActive('biodata') }">
          <employee-biodata></employee-biodata>
        </div>
        <div class="tab-pane fade" :class="{ 'active show': isActive('employment') }">
          <legend></legend>
          <employee-status-detail></employee-status-detail>
          <hr/>
          <legend>Historical of contract classication</legend>
          <contract-status-detail></contract-status-detail>
          <functional-position-detail></functional-position-detail>
          <duty-station-detail></duty-station-detail>
          <grade-detail></grade-detail>
        </div>
        <div class="tab-pane fade" :class="{ 'active show': isActive('family') }">
          <family-index></family-index>
        </div>
        <div class="tab-pane fade" :class="{'active show': isActive('personel-data')}">
          <identity-detail></identity-detail>
          <bpjs-ketenagakerjaan-detail></bpjs-ketenagakerjaan-detail>
          <bpjs-kesehatan-detail></bpjs-kesehatan-detail>
          <driving-license-detail></driving-license-detail>
          <passport-index></passport-index>
          <tax-payer-detail></tax-payer-detail>
        </div>
        <div class="tab-pane fade" :class="{'active show': isActive('contacts')}">
          <address-detail></address-detail>
          <phone-detail></phone-detail>
          <email-detail></email-detail>
          <referral-detail></referral-detail>
        </div>
        <div class="tab-pane fade" :class="{ 'active show': isActive('activities') }">
          <employee-activities :tabs="activeItem"></employee-activities>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EmployeeBiodata from "@/components/pages/employee/EmployeeBiodata";
import EmployeeStatusDetail from "@/components/pages/employee-status/EmployeeStatusDetail";
import ContractStatusDetail from "@/components/pages/contract-status/ContractStatusDetail";
import FunctionalPositionDetail from "@/components/pages/functional-position/FunctionalPositionDetail";
import DutyStationDetail from "@/components/pages/duty-station/DutyStationDetail";
import GradeDetail from "@/components/pages/grade/GradeDetail";
import IdentityDetail from "@/components/pages/identity/IdentityDetail";
import BpjsKetenagakerjaanDetail from "@/components/pages/bpjs-ketenagakerjaan/BpjsKetenagakerjaanDetail";
import BpjsKesehatanDetail from "@/components/pages/bpjs-kesehatan/BpjsKesehatanDetail";
import DrivingLicenseDetail from "@/components/pages/driving-license/DrivingLicenseDetail";
import TaxPayerDetail from "@/components/pages/taxpayer/TaxPayerDetail";
import AddressDetail from "@/components/pages/address/AddressDetail";
import PhoneDetail from "@/components/pages/phone/PhoneDetail";
import EmailDetail from "@/components/pages/email/EmailDetail";
import ReferralDetail from "@/components/pages/referral/ReferralDetail";
import PassportIndex from "../passport/PassportIndex";
import FamilyIndex from "../family/FamilyIndex";
import EmployeeActivities from "./EmployeeActivities";
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";

export default {
  name: "EmployeeInput",
  components: {
    EmployeeActivities,
    FamilyIndex,
    PassportIndex,
    ReferralDetail,
    EmailDetail,
    PhoneDetail,
    AddressDetail,
    TaxPayerDetail,
    DrivingLicenseDetail,
    BpjsKesehatanDetail,
    BpjsKetenagakerjaanDetail,
    IdentityDetail,
    GradeDetail,
    DutyStationDetail,
    FunctionalPositionDetail,
    ContractStatusDetail,
    EmployeeStatusDetail,
    EmployeeBiodata,
  },
  data() {
    return {
      activeItem: "biodata",
      detail: {
        full_name: "",
        emp_position: "",
        parent_number: "",
        var_name: "",
        photo_profile:"",
        initial:""
      }
    }
  },
  methods: {
    isActive(itemTabs) {
      return this.activeItem === itemTabs
    },
    setActive(itemTabs) {
      this.activeItem = itemTabs
    },
    errorMessage(title){
      this.$bvToast.toast(title, {
        title: `Error`,
        variant: 'danger',
        solid: true
      })
    },
    getRandomBg(){
      let bg_color = ['bg-blue','bg-indigo','bg-purple','bg-pink','bg-red','bg-orange','bg-yellow','bg-green','bg-teal','bg-cyan','bg-gray']
      const random = this.getRandomInt(0, 10);
      return bg_color[random]
    },
    getRandomInt(min, max) {
      // Create byte array and fill with 1 random number
      let byteArray = new Uint8Array(1);
      window.crypto.getRandomValues(byteArray);

      let range = max - min + 1;
      let max_range = 256;
      if (byteArray[0] >= Math.floor(max_range / range) * range)
        return this.getRandomInt(min, max);

      return min + (byteArray[0] % range);
    },
    onFileChange(e) {
      const file = e.target.files[0];
      let formData = new FormData();
      formData.append("file", file);

      AxiosCall.UploadDataForm(formData, urlApi.employee.update_avatar).then(res=>{
        if(res.success){
          this.$root.$children[0].successMessage(res.message)
          this.detail.photo_profile = res.atributes.Location;
          this.$store.commit("UPDATE_PHOTO_PROFILE", res.atributes.Location)
          localStorage.setItem('photo_profile',   res.atributes.Location)
        }
      }).catch(err=>{
        this.$root.$children[0].errorMessage(err.response.data.message)
      })
    }
  },
  mounted() {
    let userProfile = this.$store.getters.userProfile.data.attributes

    this.detail.full_name = userProfile.emp_name
    this.detail.parent_number = userProfile.emp_number
    this.detail.emp_position = userProfile.emp_position
    this.detail.var_name = userProfile.emp_unitunit
    this.detail.photo_profile = userProfile.emp_photo
    this.detail.initial = this.detail.full_name.match(/\b(\w)/g).join("")
  }
}
</script>